module.exports = __webpack_public_path__ + "img/intensives-1.f87aebd0.png";